import { Component, OnInit } from '@angular/core';
import { UiNotificationService } from '../ui-notification.service';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [Bind, Toast],
})
export class ToastComponent implements OnInit {
  toastKey = this.notificationService.toastKey;

  constructor(private readonly notificationService: UiNotificationService) {}

  ngOnInit(): void {}
}
